import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-accountmaster-menu',
  templateUrl: './accountmaster-menu.component.html',
  styleUrls: ['./accountmaster-menu.component.css']
})
export class AccountmasterMenuComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/accountmaster/accountmaster-menu/accountmaster-menu.component.ts